import { ref } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import { baseUrl } from '@/api'
import Pusher from 'pusher-js'
import { useUserStore } from '@/stores/user'
import { useRegisteredStore } from './registered'

export const usePusherStore = defineStore('pusher', () => {
  const pusher = ref<Pusher | null>(null)
  const userStore = useUserStore()

  const registeredStore = useRegisteredStore()
  const { registered } = storeToRefs(registeredStore)

  const init = () => {
    // @ts-expect-error Pusher has some custom inteface Ajax
    Pusher.Runtime.createXHR = () => {
      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true
      return xhr
    }

    pusher.value = new Pusher(import.meta.env.VITE_PUSHER_APP_KEY, {
      authEndpoint: baseUrl + '/api/v1/pusher/auth',
      cluster: 'us2',
      forceTLS: true,
    })

    const channel = pusher.value.subscribe(`phone-app-${userStore.user?.id}`)

    channel.bind('refresh', () => {
      console.log('Pusher refresh event received...')
      if (!registered.value) {
        console.log('App not registered. Refreshing...')
        window.location.reload()
      } else {
        console.log('App registered. Not taking any action.')
      }
    })

    // const userPresence = pusher.value.subscribe(`presence-app-${userStore.user?.id}`)

    // userPresence.bind('pusher:subscription_succeeded', () => {
    //   console.log('Pusher live')
    // })

    // userPresence.bind('pusher:subscription_error', () => {
    //   console.log('Pusher error')
    // })
  }

  return { pusher, init }
})
